// Tek sayfa akordiyon bölümü (Çalışma İzni)
import { useEffect, useState } from 'react';
import { Button } from '../../ui/button';
import { Check, Lock, Pencil, ArrowDown, Loader2 } from 'lucide-react';

const flashMissing = (step) => flashElement(document.querySelector(`#wizard-section-${step} [data-guide-required="true"]`));

export const flashElement = (el) => {
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.remove('attention-blink');
  void el.offsetWidth;
  el.classList.add('attention-blink');
  setTimeout(() => el.classList.remove('attention-blink'), 1800);
};

const WizardSection = ({ step, state, summary, onEdit, onContinue, canContinue, checking, continueLabel = 'Sonraki Bölüm', blockedHint = 'Kırmızı ile işaretli zorunlu alanları doldurun', children }) => {
  const isOpen = state === 'open';
  const isDone = state === 'done';
  const isLocked = state === 'locked';
  const [showMissing, setShowMissing] = useState(false);
  useEffect(() => { if (canContinue || !isOpen) setShowMissing(false); }, [canContinue, isOpen]);

  return (
    <section
      id={`wizard-section-${step.number}`}
      data-testid={`wizard-section-${step.number}`}
      className={`${showMissing ? 'wizard-show-missing ' : ''}rounded-xl border transition-[box-shadow,border-color,background-color] duration-300 scroll-mt-20 ${isOpen ? 'border-emerald-500 shadow-md bg-white' : isDone ? 'border-emerald-200 bg-emerald-50/40' : 'border-slate-200 bg-slate-50'}`}
    >
      <div
        className={`flex items-center gap-3 sm:gap-4 px-3 sm:px-5 py-3 sm:py-4 ${isDone ? 'cursor-pointer hover:bg-emerald-50 rounded-xl transition-colors' : ''}`}
        onClick={isDone ? onEdit : undefined}
        role={isDone ? 'button' : undefined}
        data-testid={`wizard-section-header-${step.number}`}
      >
        <div className={`flex items-center justify-center w-10 h-10 rounded-full shrink-0 font-semibold transition-colors ${isDone ? 'bg-emerald-600 text-white' : isOpen ? 'bg-emerald-100 text-emerald-700 ring-2 ring-emerald-500' : 'bg-slate-200 text-slate-400'}`}>
          {isDone ? <Check className="h-5 w-5" /> : isLocked ? <Lock className="h-4 w-4" /> : <step.icon className="h-5 w-5" />}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs uppercase tracking-wide text-slate-400">Bölüm {step.number}</p>
          <h3 className={`font-semibold ${isLocked ? 'text-slate-400' : 'text-slate-800'}`}>{step.title}</h3>
          {isDone && summary && <p className="text-sm text-emerald-700 truncate" data-testid={`wizard-section-summary-${step.number}`}>{summary}</p>}
          {isLocked && <p className="text-xs text-slate-400">Önceki bölümü tamamlayınca açılır</p>}
        </div>
        {isDone && (
          <Button type="button" variant="outline" size="sm" onClick={(e) => { e.stopPropagation(); onEdit(); }} data-testid={`wizard-section-edit-${step.number}`}>
            <Pencil className="h-3.5 w-3.5 mr-1" /> Düzenle
          </Button>
        )}
      </div>

      {isOpen && (
        <div className="px-3 sm:px-5 pb-4 sm:pb-5 animate-in fade-in slide-in-from-top-2 duration-300">
          <div className="border-t pt-4 sm:pt-5">{children}</div>
          {onContinue && (
            <div className="flex flex-col items-center gap-2 pt-6 mt-5 border-t">
              <button
                type="button"
                onClick={canContinue ? onContinue : () => { setShowMissing(true); flashMissing(step.number); }}
                disabled={checking}
                aria-label={continueLabel}
                className={`flex items-center justify-center w-14 h-14 rounded-full text-white shadow-lg transition-[transform,background-color,opacity] duration-200 ${checking ? 'bg-slate-300' : showMissing ? 'bg-rose-600 hover:bg-rose-700' : 'bg-emerald-600 hover:bg-emerald-700'}`}
                data-testid={`wizard-section-continue-${step.number}`}
              >
                {checking ? <Loader2 className="h-6 w-6 animate-spin" /> : <ArrowDown className={`h-6 w-6 ${showMissing ? '' : 'animate-bounce'}`} />}
              </button>
              <p className={`text-sm ${showMissing ? 'font-semibold text-rose-600' : 'text-emerald-700 font-medium'}`} data-testid={`wizard-section-continue-label-${step.number}`}>
                {checking ? 'Kontrol ediliyor...' : showMissing ? blockedHint : continueLabel}
              </p>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default WizardSection;
